module.exports = __webpack_public_path__ + "../resources/img/ic_minus_gray950.42cdc0a3.svg";